export const CONTROL_METADATA_KEY = 'metadata';
export const CONTROL_SUMMARY_KEY = 'summaryValue';
